import React from 'react';
import BoldButton from '../Common/BoldButton';

interface IProps {
  canModify: boolean;
  onClick: () => void;
  className?: string;
}

const EditViewButton = ({ canModify, onClick, className }: IProps) =>
  <BoldButton className={className} onClick={onClick}>{canModify ? 'Edit' : 'View'}</BoldButton>;

export default EditViewButton;
